/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React, { useState, useEffect } from "react";
import { Table, Space, Button, Tooltip, message, Input, Modal } from "antd";
import useCustomNavigate from "../../../components/customNavigationHook";
import "./undeliveredShipmentsList.scss";
import { ReactComponent as View_icon } from "../../../assests/images/SVG/view-details.svg";
import API from "../../../api";
import urls from "../../../api/urls";
import moment from "moment";
import search_icon from "../../../assests/images/search-icon.svg";
// import { DP_OPERATOR } from "../../../config/constants";

const UndeliveredShipmentsList = ({ tabValue }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useCustomNavigate();
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(0);
  // const userinfo = JSON.parse(localStorage.getItem("userinfo"));

  const getDeliveryPartnerId = () => {
    const deliveryPartners =
      JSON.parse(sessionStorage.getItem("deliveryPartner"))?.data || [];
    return deliveryPartners.length > 0 ? deliveryPartners[0]?.dpId : "";
  };

  useEffect(() => {
    fetchShipments();
  }, [tabValue]);

  const fetchShipments = async (p1 = 10, p2 = 0, customParams) => {
    setLoading(true);
    try {
      let queryParams;
      const dpId = getDeliveryPartnerId();
      // const role = userinfo?.role;
      if (customParams) {
        queryParams = customParams; 
        if (!customParams.has('dpId') && dpId) {
          customParams.set('dpId', dpId);
        }
      } else {
        queryParams = new URLSearchParams({
          page: (p2 + 1).toString(),
          limit: p1.toString(),
          status: "UNDELIVERED",
          dpId: dpId,
        });
      }

      const result = await API.Api(
        `${urls.GET_ORDER_BY_STATUS}?${queryParams.toString()}`
      ).get();
      const response = result?.response?.data?.data;

      if (response) {
        setTotal(response?.metadata?.total || 0);
        setData(response?.orders || []);
      }
    } catch (error) {
      console.error("Error fetching shipments:", error);
    } finally {
      setLoading(false);
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };
  const handleView = (record) => {
    navigate(`/shipments-details/${record.awbNumber}`);
  };

  const requestForRTO = async (record) => {
    const dpId = getDeliveryPartnerId();

    try {
      setLoading(true);
      await API.Api(
        `${urls.SUPERVISOR_RTO_REQUEST}?awbNumber=${record.awbNumber}&dpId=${dpId}`
      ).patch();
      message.success("RTO request submitted successfully");
      fetchShipments();
    } catch (error) {
      console.error("Error requesting RTO:", error);
      message.error(
        error?.response?.data?.message || "Failed to submit RTO request"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRTORequest = (record) => {
    Modal.confirm({
      title: "Confirm RTO Request",
      content: `Are you sure you want to request RTO for AWB: ${record?.awbNumber}?`,
      okText: "Yes",
      cancelText: "No",
      onOk: () => requestForRTO(record),
      centered: true,
      maskClosable: true,
    });
  };

  const columns = [
    {
      title: "AWB",
      dataIndex: "awbNumber",
      key: "awbNumber",
      render: (text) => text || "-",
    },
    {
      title: "Delivery Attempted On",
      dataIndex: "orderUpdatedAt",
      key: "orderUpdatedAt",
      render: (_, record) => {
        return record?.rtoDetails?.deliveryAttemptedOn
          ? `${moment(record?.rtoDetails?.deliveryAttemptedOn).format(
              "DD/MM/YYYY hh:mm A"
            )}`
          : "-";
      },
    },
    {
      title: "DA Name",
      dataIndex: "deliveryBoyName",
      key: "deliveryBoyName",
      render: (_, record) => {
        return record?.rtoDetails?.daName
          ? `${record?.rtoDetails?.daName}`
          : "-";
      },
    },
    {
      title: "DA Mobile No.",
      dataIndex: "deliveryBoyMobile",
      key: "deliveryBoyMobile",
      render: (_, record) => {
        return record?.rtoDetails?.["damobileno."]
          ? `${record?.rtoDetails["damobileno."]}`
          : "-";
      },
    },
    {
      title: "Reason for Non Delivery",
      dataIndex: "reason",
      key: "reason",
      render: (_, record) => {
        return record?.rtoDetails?.reasonForNonDelivery
          ? `${record?.rtoDetails?.reasonForNonDelivery}`
          : "-";
      },
    },
    // {
    //   title: "Proof of Non Delivery",
    //   dataIndex: "proofOfNonDelivery",
    //   key: "proofOfNonDelivery",
    // },
    {
      title: "Customer Mobile No.",
      dataIndex: "customerMobileNo",
      key: "customerMobileNo",
      render: (text, record) => {
        return record?.shippingDetails?.phone
          ? `${record?.shippingDetails?.phone}`
          : "-";
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title={"View Details"} placement="bottom">
            <p
              className="pointer"
              style={{ marginTop: "4px", marginBottom: "0" }}
              onClick={() => handleView(record)}
            >
              <View_icon />
            </p>
          </Tooltip>
          <Button type="primary" onClick={() => handleRTORequest(record)}>
            Request RTO
          </Button>
        </Space>
      ),
    },
  ];

  const handlePageChange = (pagination) => {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);

    const queryParams = new URLSearchParams({
      page: pagination.current.toString(),
      limit: pagination.pageSize.toString(),
      status: "UNDELIVERED",
      dpId: getDeliveryPartnerId(),
    });
    fetchShipments(pagination.pageSize, pagination.current - 1, queryParams);
  };

  const onSearch = async (e) => {
    const searchQuery = e.target.value;
    if (searchQuery) {
      const queryParams = new URLSearchParams({
        awbNumber: searchQuery,
        status: "UNDELIVERED",
        dpId: getDeliveryPartnerId(),
      });
      fetchShipments(10, 0, queryParams);
    } else {
      fetchShipments();
    }
  };

  return (
    <div className="undelivered-shipments-list master-main-container m-1 p-1">
      <div className="p-1" style={{ display: "flex", justifyContent: "end" }}>
        <Input
          placeholder="Search by AWB Number"
          bordered
          style={{ borderRadius: "5px", height: "40px", width: "465px" }}
          suffix={<img src={search_icon} />}
          onChange={(e) => {
            onSearch(e);
          }}
        />
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        pagination={{
          pageSize: pageSize,
          total: total,
          itemRender: itemRender,
          current: pageNum == 0 ? +1 : pageNum,
        }}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default UndeliveredShipmentsList;
